import VueGtag from 'vue-gtag-next';

export default function installGtag(app, router, analyticsId) {
  app.use(
    VueGtag,
    {
      property: {
        id: analyticsId,
      },
    },
    router
  );
}
